import * as Yup from 'yup';

export const SignUpPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(
      /[@$!%*?&]/,
      'Password must contain at least one special character'
    ),
  terms: Yup.array()
    .min(1, 'You must accept the terms and conditions')
    .required('You must accept the terms and conditions'),
});

export type SignUpPasswordDataType = Yup.InferType<typeof SignUpPasswordSchema>;

type InitialValues = {
  password: string;
  terms: string[];
};

export const signUpPasswordInitialValues: InitialValues = {
  password: '',
  terms: [],
};


export interface PasswordSliderInterface {
  password: string;
  terms: string[];
};
